import React, { useContext, useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { LiveKitRoom as LiveKitRoomBase, VideoConference as VideoConferenceBase } from '@livekit/components-react';
import '@livekit/components-styles';
import { AxiosContext } from '../contextManager/axios.context';
import { useUser } from '../contextManager/user.context';
import { endpoints } from '../constants/endpoints';

// LiveKit types these components as returning ReactNode, which React 18.3's JSX
// typing rejects; alias them to FC for use as components.
const LiveKitRoom = LiveKitRoomBase as unknown as React.FC<any>;
const VideoConference = VideoConferenceBase as unknown as React.FC<any>;

const fullscreen: React.CSSProperties = {
  position: 'fixed',
  inset: 0,
  zIndex: 10000,
  background: '#000',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const VideoRoom = () => {
  const { eventId } = useParams<{ eventId: string }>();
  const navigate = useNavigate();
  const axios = useContext(AxiosContext);
  const { userDetails } = useUser();

  const [token, setToken] = useState<string>();
  const [serverUrl, setServerUrl] = useState<string>();
  const [error, setError] = useState<string>();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await axios.post(endpoints.videoToken, {
          eventId,
          name: userDetails?.name,
        });
        if (!cancelled) {
          setToken(data.token);
          setServerUrl(data.url);
        }
      } catch (err: any) {
        if (!cancelled) {
          const status = err?.response?.status;
          const serverMsg = err?.response?.data?.message;
          const detail = serverMsg || err?.message || 'unknown error';
          setError(`Unable to join this lesson. [${status ?? 'no status'}] ${detail}`);
          console.error('VideoRoom /video/token failed:', { status, serverMsg, err });
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [eventId, axios, userDetails?.name]);

  if (error) {
    return (
      <div style={fullscreen}>
        <div style={{ color: 'white', textAlign: 'center' }}>
          <p>{error}</p>
          <button onClick={() => navigate('/lessons')}>Back to lessons</button>
        </div>
      </div>
    );
  }

  if (!token || !serverUrl) {
    return (
      <div style={fullscreen}>
        <p style={{ color: 'white' }}>Connecting…</p>
      </div>
    );
  }

  return (
    <div style={fullscreen} data-lk-theme="default">
      <LiveKitRoom
        serverUrl={serverUrl}
        token={token}
        connect
        video
        audio
        onDisconnected={() => navigate('/lessons')}
        style={{ height: '100%', width: '100%' }}
      >
        <VideoConference />
      </LiveKitRoom>
    </div>
  );
};

export default VideoRoom;
